import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import './styles.scss';

const ListItem = ({ label, check }) => (
  <li key={label} className={cx('reactivate-perk', { strike: !check })}>
    <i className={`fas ${check ? 'fa-check' : 'fa-times'}`} />
    <span>{label}</span>
  </li>
);

ListItem.defaultProps = {
  label: '',
  check: false,
};

ListItem.propTypes = {
  label: PropTypes.string,
  check: PropTypes.bool,
};

ListItem.displayName = 'ListItem';

export default ListItem;
